import { wp_rest_baseurl, wp_rest_api_nonce } from "./config";
import { AJAX_FILE_UPLOAD } from "./helpers";

const doUploadBtn = document.querySelector('#upload-file-btn');
const uploadField = document.querySelector('#upload-file-field');
const fileInfoBoxCont = document.querySelector('#uploaded-file');
const fileUploadProgress = fileInfoBoxCont.querySelector('.upload-file-wrap');
const fileUploadResponse = fileInfoBoxCont.querySelector('.upload-file-response');

const goBackUploadDiv = document.querySelector('.go-back-upload');
const goBackUploadBtn = document.querySelector('.go-back-upload .go-back-upload-btn');

const submitForm = document.querySelector('#send_transport_solution');

doUploadBtn.addEventListener('click', (e) => {
    try {
        e.preventDefault();

        uploadField.value = "";
        uploadField.click();
    } catch (err) {
        throw err;
    }
});

uploadField.addEventListener('change', () => {
    try {
        submitForm.setAttribute('disabled', true);
        doUploadBtn.setAttribute('disabled', true);

        // Clean up progress bar
        fileInfoBoxCont.querySelector('.upload-progress-bar').style.width = '0%';
        fileInfoBoxCont.querySelector('.upload-pg').innerText = '0%';

        doUploadBtn.classList.add('hide');
        fileUploadProgress.classList.remove('hide');
        
        uploadFile();
    } catch (err) {
        throw err;
    }
});

function uploadFile() {
    try {
        const transportReqID = document.querySelector('input[name="transport_req_id"]').value;

        const formData = new FormData();
        const file = uploadField.files[0]; // Get the first file only

        formData.append('file', file);
        formData.append('request_id', transportReqID);

        AJAX_FILE_UPLOAD(
            `${wp_rest_baseurl}v1/transporter-actions-ep/upload-file`,
            formData,
            (progress) => {
                // Calc upload percentage
                const uploadPG = Math.trunc((progress.loaded / progress.total) * 100) + '%';

                // Show upload progress
                fileInfoBoxCont.querySelector('.upload-progress-bar').style.width = uploadPG;
                fileInfoBoxCont.querySelector('.upload-pg').innerText = uploadPG;
            }
        )
        .then((response) => {
            const res = response.data;

            fileUploadProgress.classList.add('hide');
            fileUploadResponse.classList.remove('hide');

            if (res.status.toLowerCase() === 'error') {
                createFileUploadErrorBox( res.message );
                fileUploadResponse.classList.remove('hide');

                // Show go back
                goBackUploadDiv.classList.remove('hide');
                goBackUploadBtn.addEventListener('click', () => {
                    goBackToUpload();
                });
            }

            if (res.status.toLowerCase() === 'success') {
                const fileInfoBox = createFileInfoBox( res.upload_id, res.file_data.name, res.file_data.size );

                const cancelUploadedFile = fileInfoBox.querySelector('.file-cancel');
                const fileBoxLoader = fileInfoBox.querySelector('.loader');

                submitForm.removeAttribute('disabled');

                cancelUploadedFile.addEventListener('click', (e) => {
                    e.preventDefault();

                    if (cancelUploadedFile.getAttribute('disabled')) return; 

                    submitForm.setAttribute('disabled', true)
                    fileBoxLoader.classList.remove('hide');

                    const uploadedFileID = cancelUploadedFile.getAttribute('data-upload-id');

                    cancelUploadedFile.setAttribute('disabled', true);

                    deleteUploadedFile( uploadedFileID, transportReqID, fileInfoBox );
                });
            }

            console.log(response.data);
        })
        .catch((error) => {
            // Create file upload error
            createFileUploadErrorBox();
            fileUploadResponse.classList.remove('hide');

            // Show go back
            goBackUploadDiv.classList.remove('hide');
            goBackUploadBtn.addEventListener('click', () => {
                goBackToUpload();
            });

            throw error;
        })
    } catch (err) {
        throw err;
    }
}

/**
 * Call this function to delete an upload giving the file upload ID.
 * 
 * @param {} fileUploadID 
 */
function deleteUploadedFile(fileUploadID, transportReqID, fileInfoBox) {
    const XHR = new XMLHttpRequest();
    const formData = new FormData();

    formData.append('file_action', 'delete_file');
    formData.append('file_upload_id', fileUploadID);
    formData.append('transport_req_id', transportReqID);

    XHR.open('POST', `${wp_rest_baseurl}v1/transporter-actions-ep/delete-upload-file`, true);
    XHR.addEventListener('readystatechange', () => {
        if (XHR.readyState === XHR.DONE && XHR.status === 200) {
            const response = JSON.parse( XHR.response );

            if (response.status === 'error') {
                setTimeout(
                    () => {
                        fileInfoBox.querySelector('.loader').classList.add('hide');
                        fileInfoBox.querySelector('.file-cancel').removeAttribute('disabled');

                        fileInfoBox.querySelector('.file-box-actions').innerHTML += `<p class='cancel-file-loader-msg'>${response.message}</p>`;
                    }, 1500
                )
            }

            if (response.status === 'success') {
                setTimeout(
                    () => {
                        fileInfoBox.querySelector('.loader').classList.add('hide');
                        fileInfoBox.remove();

                        doUploadBtn.removeAttribute('disabled');
                        doUploadBtn.classList.remove('hide');
                    }, 1500
                )
            }
            console.log(response);
        }
    });
    XHR.setRequestHeader('X-WP-Nonce', wp_rest_api_nonce);
    XHR.send(formData);
}

function createFileInfoBox(uploadId, fileName, fileSize) {
    try {
        fileUploadResponse.innerHTML = `
        <div id="up_${uploadId}" class="file-upload-box">
            <div class="file-box-wrap">
                <div class="file-type-icon">${pdfSvgIcon()}</div>
                <div class="file-meta">
                    <div class="file-name">${fileName}</div>
                    <div class="progress-wrap">
                        <div class="progress">
                            <div class="progress-bar" style=""></div>
                        </div>
                        <div class="progress-pg"></div>
                    </div>
                </div>
            </div>
            <div class="file-box-actions">
                <button class="file-cancel" data-upload-id="${uploadId}">
                    ${closeSvgIcon()} Cancella file
                </button>
                <div class="loader hide"></div>
            </div>
        </div>`;

        return document.querySelector(`#up_${uploadId}`);
    } catch (err) {
        throw err;
    }
}

function createFileUploadErrorBox(errorMsg = '') {
    fileUploadResponse.innerHTML = `
    <div class="upload-error mb-10 mt-10">
        <i class="fas fa-times"></i>
        ${ errorMsg === '' ? 'Impossibile caricare il tuo file. Riprova di nuovo.' : errorMsg }
    </div>`;
}

function goBackToUpload() {
    // Show upload button and UNLOCK removing disabled ATTRIBUTE
    doUploadBtn.removeAttribute('disabled');
    doUploadBtn.classList.remove('hide');

    // Hide go back upload button and response
    fileUploadResponse.classList.add('hide');
    goBackUploadDiv.classList.add('hide');

    // Hide progress bar
    fileUploadProgress.classList.add('hide');
}

function pdfSvgIcon() {
    return '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><path style="fill:#E2E5E7;" d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"></path><path style="fill:#B0B7BD;" d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"></path><polygon style="fill:#CAD1D8;" points="480,224 384,128 480,128 "></polygon><path style="fill:#F15642;" d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z"></path><g><path style="fill:#FFFFFF;" d="M101.744,303.152c0-4.224,3.328-8.832,8.688-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.688-3.184-8.688-8.816V303.152z M118.624,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H118.624z"></path><path style="fill:#FFFFFF;" d="M196.656,384c-4.224,0-8.832-2.304-8.832-7.92v-72.672c0-4.592,4.608-7.936,8.832-7.936h29.296c58.464,0,57.184,88.528,1.152,88.528H196.656z M204.72,311.088V368.4h21.232c34.544,0,36.08-57.312,0-57.312H204.72z"></path><path style="fill:#FFFFFF;" d="M303.872,312.112v20.336h32.624c4.608,0,9.216,4.608,9.216,9.072c0,4.224-4.608,7.68-9.216,7.68h-32.624v26.864c0,4.48-3.184,7.92-7.664,7.92c-5.632,0-9.072-3.44-9.072-7.92v-72.672c0-4.592,3.456-7.936,9.072-7.936h44.912c5.632,0,8.96,3.344,8.96,7.936c0,4.096-3.328,8.704-8.96,8.704h-37.248V312.112z"></path></g><path style="fill:#CAD1D8;" d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"></path><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>fff<g></g><g></g><g></g></svg>';
}

function closeSvgIcon() {
    return '<svg height="512" viewBox="0 0 32 32" width="512" xmlns="http://www.w3.org/2000/svg" id="fi_2734822"><g id="Layer_22" data-name="Layer 22"><path d="m21 12.46-3.59 3.54 3.59 3.54a1 1 0 0 1 0 1.46 1 1 0 0 1 -.71.29 1 1 0 0 1 -.7-.29l-3.59-3.59-3.54 3.59a1 1 0 0 1 -.7.29 1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l3.54-3.59-3.54-3.54a1 1 0 0 1 1.41-1.41l3.54 3.54 3.54-3.54a1 1 0 0 1 1.46 1.41zm4.9 13.44a14 14 0 1 1 0-19.8 14 14 0 0 1 0 19.8zm-1.41-18.39a12 12 0 1 0 0 17 12 12 0 0 0 0-17z"></path></g></svg>';
}